import React, {FC} from "react";
import cn from "classnames";

import st from "./itemList.module.scss";

interface ItemList extends React.LiHTMLAttributes<HTMLLIElement> {
  children?: React.ReactNode,
  className?: string,
  style?: React.CSSProperties
}

const ItemList: FC<ItemList> = (props) => {
  
  const {
    children,
    className,
    style,
    ...rest
  } = props
  
  return (
    <li
      className={cn(
        st.itemList,
        className
      )}
      style={style}
      {...rest}
    >
      {children}
    </li>
  )
  
}
export default ItemList;